
// filepath: \\wsl.localhost\Ubuntu\home\simeds\sisketron2\master\frontend\src\common\Tooltip.jsx
import React, { useState } from 'react';

/**
 * @description Un componente Tooltip che mostra un testo informativo al passaggio del mouse.
 * @param {React.Node} children - L'elemento figlio su cui attivare il tooltip.
 * @param {string} text - Il testo da visualizzare all'interno del tooltip.
 * @param {'top'|'bottom'|'left'|'right'} [position='top'] - La posizione del tooltip rispetto all'elemento.
 */
function Tooltip({ children, text, position = 'top' }) {
  const [isVisible, setIsVisible] = useState(false);

  // Se non c'è testo per il tooltip, non renderizzare nulla e restituisci solo i figli.
  if (!text) {
    return <>{children}</>;
  }

  // Classi CSS per il posizionamento del tooltip.
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={`
            absolute z-50 px-3 py-1.5 text-sm font-medium text-white bg-gray-800 rounded-lg shadow-sm dark:bg-gray-900
            whitespace-nowrap transition-opacity duration-300
            ${positionClasses[position]}
          `}
        >
          {text}
        </div>
      )}
    </div>
  );
}

export default Tooltip;
